exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".circleButton{width:15px;height:15px;border-radius:100%;border:1px solid rgba(82,87,98,0.4);display:flex;flex-direction:row;justify-content:center;align-items:center;padding:10px;cursor:pointer;transition:all ease-in-out .3s}.circleButton:hover{border:1px solid #525762}.circleButton svg{width:32px;height:32px}\n", ""]);

